import { FC } from 'react';
import { BoxProps, HStack } from '@chakra-ui/react';

import Chip from 'components/_core/Chip';

import { CardFilters } from '../../types';
import locales from './locales';

interface FilterBarProps extends BoxProps {
  disableOwnCardsFilter?: boolean;
  filter: CardFilters;
  setFilter: (filter: CardFilters) => void;
}

const FilterBar: FC<FilterBarProps> = ({
  disableOwnCardsFilter,
  filter,
  setFilter,
  ...props
}) => (
  <HStack spacing="space-16" {...props}>
    <Chip
      isActive={filter === CardFilters.COMPANY}
      onClick={() => setFilter(CardFilters.COMPANY)}
    >
      {locales.filters[CardFilters.COMPANY]}
    </Chip>

    <Chip
      isActive={filter === CardFilters.OWN}
      isDisabled={disableOwnCardsFilter}
      onClick={() => setFilter(CardFilters.OWN)}
    >
      {locales.filters[CardFilters.OWN]}
    </Chip>
  </HStack>
);

export default FilterBar;
